import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';

import { DocumentActions } from '../../reflux/document_store';
import DocumentHelper from '../../helpers/document_helper';

import { GridFormStore } from 'grid_form/reflux/grid_form_store';
import { ProcessAPI } from 'lecom-api';
import { FormActions } from '../../../form/reflux/form_store';

const DownloadDocumentButton = (props) => {
	let permissionDigitalSigned = props.pdfSigned;
	let visibleSigned = true;
	const allowsSummary = props.allowsSummary;
	const summaryEnabled = props.summaryEnabled;

	const storeItem = GridFormStore.store[props.gridId];

	if (storeItem && storeItem.propsRows && props.tableRowData && storeItem.propsRows[props.tableRowData.id] && storeItem.propsRows[props.tableRowData.id].visibleSigned === false)
		visibleSigned = storeItem.propsRows[props.tableRowData.id].visibleSigned;

	return (
		<div className='container-cell-document'>
			{(allowsSummary && summaryEnabled && !isPublic()) &&
				<Tooltip placement="top" overlay={Realize.i18n.t('template.actions.summary')} showArrow={false}>
					<a id="anchor-summary" onClick={() => summaryDocument(props)}>
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#000000" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sparkles icon-summary">
							<path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/>
						</svg>
					</a>
				</Tooltip>
			}

			{(permissionDigitalSigned === true && visibleSigned === true && getSignPermission()) ?
				<Tooltip placement="top" overlay={Realize.i18n.t('template.actions.digitalSignature')} showArrow={false}>
					<a id="anchor-digital-signature" onClick={() =>  digitalSignature(props) }>
						<svg className='icon-certificate-digital' xmlns="http://www.w3.org/2000/svg" fill="#343434" width="24" height="24" viewBox="0 0 24 24">
							<path d="M4,3C2.89,3 2,3.89 2,5V15A2,2 0 0,0 4,17H12V22L15,19L18,22V17H20A2,2 0 0,0 22,15V8L22,6V5A2,2 0 0,0 20,3H16V3H4M12,5L15,7L18,5V8.5L21,10L18,11.5V15L15,13L12,15V11.5L9,10L12,8.5V5M4,5H9V7H4V5M4,9H7V11H4V9M4,13H9V15H4V13Z"/>
							<path d="M0 0h24v24H0z" fill="none"/>
						</svg>
					</a>
				</Tooltip>
			: ''}

			<Tooltip placement="top" overlay={Realize.i18n.t('template.actions.previewDocument')} showArrow={false}>
				<a id="view-document-cell" onClick={(event) => viewDocumentCell(event, props)}>
					<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
						<path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Z"/>
					</svg>
				</a>
			</Tooltip>

			<a className="table-cell__content" href="#" onClick={(event) => downloadDocument(event, props)}>
				{ DocumentHelper.getFileNameFromDocumentValue(props.value) }
			</a>
		</div>
	);
};

const isPublic = () => {
	const currentProcess = ProcessAPI.currentProcess();
	return currentProcess ? !!currentProcess.isPublic() : false;
}

const summaryDocument = (props) => {
	const value = props.value;
	let valueSplit = value.split(':');
	let fileName = valueSplit[0];
	let fileUUID = valueSplit[1];

	const inputDocumentValue = {
		fileName: fileName || '',
		fileUUID: fileUUID || ''
	};

	FormActions.openDrawerAI(props.formId, props.name, inputDocumentValue, true);
}

const getSignPermission = () => {
	const processAPI = ProcessAPI.currentProcess();
	const signPermission = processAPI.signPermission();

	return !!signPermission;
}

const downloadDocument = (event, props) => {
	event.preventDefault();
	DocumentActions.downloadDocumentFile(props.name, DocumentHelper.parseDocumentValue(props.value));
};

const digitalSignature = (props) => {
	const value = props.value;
	let valueSplit = value.split(':');
	let fileName = valueSplit[0];
	let fileUUID = valueSplit[1];

	const inputDocumentValue = {
		fileName: fileName || '',
		fileUUID: fileUUID || ''
	};

	window.currentDocumentIdSign = null;

	window.gridDataSign = {
		gridId: props.gridId,
		name: props.name,
		value: props.value
	}

	DocumentActions.openDigitalSignature(inputDocumentValue);
}

const viewDocumentCell = (event, props) => {
	event.preventDefault();

	const value = props.value;
	const valueSplit = value.split(':');
	const fileUUID = valueSplit[1];

	DocumentActions.previewDocumentFile(fileUUID);
}

DownloadDocumentButton.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	pdfSigned: PropTypes.string.isRequired,
	isMobile: PropTypes.string.isRequired
};

export default DownloadDocumentButton;
